export function getUserInfo(): Record<string, never> {
  const user = localStorage.getItem('user') || '';
  return JSON.parse(user)?.user;
}
